export default function useGetLines(selectedLines) {
  const result = [];
  for (let i = 0; i < selectedLines.length; i++) {
    let isExist = false;
    for (let j = 0; j < result.length; j++) {
      if (
        selectedLines[i].lineTurnUid === result[j].lineTurnUid &&
        selectedLines[i].onStationUid === result[j].onStationUid &&
        selectedLines[i].offStationUid === result[j].offStationUid
      ) {
        isExist = true;
        result[j].terms.push(selectedLines[i].terms[0]);
        break;
      }
    }
    if (!isExist) {
      const { lineTurnUid, onStationUid, offStationUid, terms } =
        selectedLines[i];
      result.push({
        lineTurnUid,
        onStationUid,
        offStationUid,
        terms,
      });
    }
  }
  return result;
}
